module.exports = __webpack_public_path__ + "static/media/icon_estado_finalizado.7da42882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_estado_finalizado.svg
// module id = 621
// module chunks = 0